(function () {
  const GENERAL_COOKIE_CONFIRMED = "general-cookies-confirmed";
  const ANALYTICS_COOKIE_CONFIRMED = "analytics-cookies-confirmed";
  const MARKETING_COOKIE_CONFIRMED = "marketing-cookies-confirmed";
  const CONSENT_DURATION = 7;

  // First-user-interaction signal (see whenUserInteracts() below).
  const USER_INTERACTION = new Promise<void>((resolve) => {
    const events = [
      "pointerdown",
      "mousemove",
      "keydown",
      "wheel",
      "touchstart",
      "scroll",
    ];
    let fired = false;
    const onFirst = () => {
      if (fired) return;
      fired = true;
      events.forEach((evt) => window.removeEventListener(evt, onFirst));
      (window as Window & { __userInteracted?: boolean }).__userInteracted =
        true;
      document.dispatchEvent(new CustomEvent("user-interaction"));
      resolve();
    };
    events.forEach((evt) =>
      window.addEventListener(evt, onFirst, { passive: true }),
    );
  });

  const cookiesBanner = document.getElementById("cookie-banner") as
    | HTMLDialogElement
    | undefined;

  const cookiesCustomizeModal = document.getElementById(
    "cookie-customize-modal",
  ) as HTMLDialogElement | undefined;

  const cookiesSettingsForm = document.getElementById(
    "cookie-settings-form",
  ) as HTMLFormElement | undefined;

  const resetButton = document.querySelector(
    "[data-function='reopen-cookie-banner']",
  ) as HTMLButtonElement | undefined;

  cookiesBanner?.addEventListener("click", handleBannerInteractions);
  cookiesCustomizeModal?.addEventListener("click", handleBannerInteractions);
  resetButton?.addEventListener("click", handleBannerInteractions);

  if (getCookie(GENERAL_COOKIE_CONFIRMED) !== "true") {
    whenUserInteracts().then(() => cookiesBanner?.show());
  }

  /**
   * Resolves once on the first real user interaction, then tears its listeners
   * down. Latched (callers awaiting after the fact still resolve), so there's no
   * missed-event race. Also sets `window.__userInteracted` and dispatches a
   * one-shot `user-interaction` event, so other modules can defer optional work
   * off the same signal. Inlined here for now to keep cookie-banner a single
   * self-contained classic-script bundle — see note below.
   */
  function whenUserInteracts() {
    return USER_INTERACTION;
  }

  function handleBannerInteractions(event: MouseEvent) {
    if (!(event.target instanceof HTMLElement)) return;
    const { function: fn } = event.target.dataset;

    switch (fn) {
      case "cookie-accept-all":
        acceptAll();
        break;
      case "cookie-deny-all":
        denyAll();
        break;
      case "cookie-customize":
        cookiesBanner?.close();
        cookiesCustomizeModal?.showModal();
        break;
      case "cookie-save-customized":
        saveCustomized();
        break;
      case "cookie-close-customize":
        cookiesCustomizeModal?.close();
        cookiesBanner?.show();
        break;
      case "reopen-cookie-banner":
        reopenCookieBanner();
        break;
    }
  }

  function reopenCookieBanner() {
    if (getCookie(ANALYTICS_COOKIE_CONFIRMED) === "true") {
      const analyticsCheckbox = cookiesSettingsForm?.querySelector(
        "[name='analytics-cookies']",
      ) as HTMLInputElement | null;
      analyticsCheckbox?.click();
    }

    if (getCookie(MARKETING_COOKIE_CONFIRMED) === "true") {
      const marketingCheckbox = cookiesSettingsForm?.querySelector(
        "[name='marketing-cookies']",
      ) as HTMLInputElement | null;
      marketingCheckbox?.click();
    }

    cookiesBanner?.show();
  }

  function acceptAll() {
    setCookie(GENERAL_COOKIE_CONFIRMED, "true", CONSENT_DURATION);
    setCookie(ANALYTICS_COOKIE_CONFIRMED, "true", CONSENT_DURATION);
    setCookie(MARKETING_COOKIE_CONFIRMED, "true", CONSENT_DURATION);
    refreshPage();
  }

  function denyAll() {
    setCookie(GENERAL_COOKIE_CONFIRMED, "true", CONSENT_DURATION);
    setCookie(ANALYTICS_COOKIE_CONFIRMED, "false", CONSENT_DURATION);
    setCookie(MARKETING_COOKIE_CONFIRMED, "false", CONSENT_DURATION);
    refreshPage();
  }

  function saveCustomized() {
    const cookiesFormData = new FormData(cookiesSettingsForm);
    const analytics = cookiesFormData.get("analytics-cookies") === "on";
    const marketing = cookiesFormData.get("marketing-cookies") === "on";

    setCookie(GENERAL_COOKIE_CONFIRMED, "true", CONSENT_DURATION);

    setCookie(
      ANALYTICS_COOKIE_CONFIRMED,
      analytics ? "true" : "false",
      CONSENT_DURATION,
    );
    setCookie(
      MARKETING_COOKIE_CONFIRMED,
      marketing ? "true" : "false",
      CONSENT_DURATION,
    );
    refreshPage();
  }

  function refreshPage() {
    // eslint-disable-next-line no-self-assign
    location.href = location.href;
  }

  function setCookie(
    cookieName: string,
    cookieValue: string,
    daysToExpire: number,
  ) {
    const date = new Date();
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie =
      cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }

  function getCookie(cookieName: string) {
    let cookieValue = null;
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(cookieName + "=")) {
        cookieValue = cookie.substring(cookieName.length + 1);
        break;
      }
    }
    return cookieValue;
  }
})();
